import React from 'react';
import ModalBasic from "../../pages/component/ModalBasic";
import TextInput from "../UIComponent/TextInput";
import DropdownSelect from "../dropdown/Dropdown";
import Validation from "../../utils/validation/ValidationText"

export default function EditViewNewBooking(props) {
  return (
    <>
      <ModalBasic
        id="upload-booking-reports"
        className="upload-booking-reports"
        modalOpen={props.setEditViewNewBooking}
        setModalOpen={props.setOpenModal}
        title="Edit Booking"
      >
        <div className="bg-white p-8 rounded-lg shadow-lg w-[1000px]">
          {/* Form Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* First Name with Dropdown */}
            <div>
              <h2 className="text-xl text-[#757575] font-bold mb-2">
                First Name <span className="text-[#c00000]">*</span>
              </h2>
              <div className="dropdwn-input flex items-center">
                <DropdownSelect
                  drpIdentity={"MrMrs"}
                  optionArray={props.mrMrsList}
                  setFilterParameters={props.setFilterParameters}
                  value={props.editViewNewBooking.salutation}

                />

                <TextInput
                  placeholder=""
                  type="text"
                  name="firstName"
                  value={props.editViewNewBooking.firstName}
                  handleChange={(e) => props.handlechangeForEdit(e)}
                  onBlur={(e) => props.validate("firstName")}
                />

              </div>
              <Validation error={props.validState.error.salutation} />

              <Validation error={props.validState.error.firstName} />


            </div>

            {/* Last Name */}
            <div>
              <h2 className="text-xl text-[#757575] font-bold mb-2">
                Last Name <span className="text-[#c00000]">*</span>
              </h2>
              <TextInput
                placeholder=""
                type="text"
                name="lastName"
                value={props.editViewNewBooking.lastName}
                handleChange={(e) => props.handlechangeForEdit(e)}
                onBlur={(e) => props.validate("lastName")}
              />
              <Validation error={props.validState.error.lastName} />
            </div>


            {/* Contact Number */}
            <div>
              <h2 className="text-xl text-[#757575] font-bold mb-2">
                Contact Number <span className="text-[#c00000]">*</span>
              </h2>
              <TextInput
                placeholder=""
                type="number"
                name="contactNo"
                value={props.editViewNewBooking.contactNo}
                handleChange={(e) => props.handlechangeForEdit(e)}
                onBlur={(e) => props.validate("contactNo")}
              />
              <Validation error={props.validState.error.contactNo} />
            </div>


            {/* Company Name */}
            <div>
              <h2 className="text-xl text-[#757575] font-bold mb-2">
                Company Name 
              </h2>
              <TextInput
                placeholder=""
                type="text"
                name="companyName"
                value={props.editViewNewBooking.companyName}
                handleChange={(e) => props.handlechangeForEdit(e)}
              //onBlur={(e) => props.validate("companyName")}
              />
              {/* <Validation error={props.validState.error.companyName} /> */}
            </div>


            {/* Company UEN */}
            <div>
              <h2 className="text-xl text-[#757575] font-bold mb-2">
                Company UEN 
              </h2>
              <TextInput
                placeholder=""
                type="text"
                name="companyUEN"
                value={props.editViewNewBooking.companyUEN}
                handleChange={(e) => props.handlechangeForEdit(e)}
              // onBlur={(e) => props.validate("companyUEN")}
              />
              {/* <Validation error={props.validState.error.companyUEN} /> */}
            </div>
            {
               props.editViewNewBooking.isCorporate === true ? 
               <div>
              <h2 className="text-xl text-[#757575] font-bold mb-2">
                HR's Company 
              </h2>
              <TextInput
                placeholder=""
                type="text"
                name="companyHR"
                value={props.editViewNewBooking.companyHR}
                handleChange={(e) => props.handlechangeForEdit(e)}
              // onBlur={(e) => props.validate("companyUEN")}
              />
              {/* <Validation error={props.validState.error.companyUEN} /> */}
            </div> : null
            }
            

            {/* Table Number */}
            {/* <div>
              <h2 className="text-xl text-[#757575] font-bold mb-2">
                Table Number <span className="text-[#c00000]">*</span>
              </h2>
              <TextInput
                placeholder=""
                type="text"
                name="tableNumber"
                value={props.editViewNewBooking.tableNumber}
                handleChange={(e) => props.handleChange(e)}
                onBlur={(e) => props.validate("tableNumber")}
              />
              <Validation error={props.validState.error.tableNumber} />
            </div> */}

          </div>

          {/* Update Button */}
          <div className="mt-10 flex justify-end">
            <button className="w-32 px-7 py-3 text-xl bg-red-600 hover:bg-red-700 text-white font-semibold rounded"
              onClick={() => props.updateNewBookingDetailsById(props.editViewNewBooking.bookingAttendeeInformationId)}>
              Update
            </button>
          </div>
        </div>
      </ModalBasic>
    </>
  );
}
